import apiClient from './api';

export const getOpenJobsForBuyer = async () => {
  try {
    const response = await apiClient.get('/jobs/my-open-jobs');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createDirectHireOffer = async (data) => {
  try {
    const response = await apiClient.post('/jobs/direct-hire', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const acceptJobOffer = async (jobId) => {
  try {
    const response = await apiClient.post(`/jobs/${jobId}/accept-offer`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const requestJobStart = async (jobId) => {
  try {
    const response = await apiClient.post(`/jobs/${jobId}/request-start`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const requestJobCompletion = async (jobId) => {
  try {
    const response = await apiClient.post(`/jobs/${jobId}/request-completion`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const confirmJobStart = async (jobId) => {
  try {
    const response = await apiClient.post(`/jobs/${jobId}/confirm-start`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const confirmJobCompletion = async (jobId) => {
  try {
    const response = await apiClient.post(`/jobs/${jobId}/confirm-completion`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const selectBidders = async (jobId, selectedBidderIds) => {
  try {
    const response = await apiClient.put(`/jobs/${jobId}/select-bidders`, { selectedBidderIds });
    return response.data;
  } catch (error) {
    throw error;
  }
};
